import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Themed"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "themed-component"
    }}>{`Themed component`}</h1>
    <p>{`Use the `}<inlineCode parentName="p">{`Themed`}</inlineCode>{` components dict to render UI with styles from
`}<a parentName="p" {...{
        "href": "/theming#styles"
      }}><inlineCode parentName="a">{`theme.styles`}</inlineCode></a>{` `}<em parentName="p">{`outside`}</em>{` of MDX. For example, if you'd like
to reuse heading styles in a React component, you can use the `}<inlineCode parentName="p">{`Themed.h1`}</inlineCode>{`
component to render an `}<inlineCode parentName="p">{`<h1>`}</inlineCode>{` element with styles from `}<inlineCode parentName="p">{`theme.styles.h1`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// example
import { Themed } from 'theme-ui'

export default (props) => (
  <div>
    <Themed.h1>Hello, styled heading!</Themed.h1>
  </div>
)
`}</code></pre>
    <p>{`For a full list of keys available, see the
`}<a parentName="p" {...{
        "href": "/theme-spec#styles"
      }}>{`Theme Specification docs`}</a>{`.`}</p>
    <h2 {...{
      "id": "global-styles"
    }}>{`Global Styles`}</h2>
    <p>{`To add base typographic styles to the `}<inlineCode parentName="p">{`<html>`}</inlineCode>{` element, add styles to
`}<inlineCode parentName="p">{`theme.styles.root`}</inlineCode>{`. Previous versions of Theme UI used the `}<inlineCode parentName="p">{`Themed.root`}</inlineCode>{`
component. See the `}<a parentName="p" {...{
        "href": "/theming/#root-styles"
      }}>{`theming docs`}</a>{` for more information.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      